import { render } from "./CustomMultiSelect.vue?vue&type=template&id=a8634e58&scoped=true"
import script from "./CustomMultiSelect.vue?vue&type=script&lang=js"
export * from "./CustomMultiSelect.vue?vue&type=script&lang=js"

import "./CustomMultiSelect.vue?vue&type=style&index=0&id=a8634e58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8634e58"]])

export default __exports__